import ability from './ability';
import { isActiveAdminDkp } from './activeAdminDkp';
import { hasExplicitModuleAccess as hasExplicitAccess } from './homePermission';

export const hasExplicitModuleAccess = (action, subject, rules = ability.rules) => (
  subject === 'AssistenciaTecnica'
    ? Array.isArray(rules) && rules.some(rule => !rule.inverted && rule.subject === subject && rule.action === action)
    : hasExplicitAccess(action, subject, rules)
);

export const canNavigate = (to) => {
  if (to.matched.some(route => route.meta.activeAdminDkpOnly) && !isActiveAdminDkp()) return false;
  return to.matched.some((route) => {
  const action = route.meta.action || 'read';
  const resource = route.meta.resource || 'Auth';
  return route.meta.explicitModule
    ? hasExplicitModuleAccess(action, resource)
    : ability.can(action, resource);
  });
};

export const _ = undefined;
